import moment from "moment";
import React, { useEffect, useState } from "react";
import Countdown, { zeroPad } from "react-countdown";
import { useSelector } from "react-redux";
import { bailiffJobDetailSelector } from "store/bailiff/bailiff/job/bailiff_job.selector";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const ConfirmCountdown = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  const [countdown, setCountdown] = useState(null);
  // -------------------------- REDUX ---------------------------
  const detail = useSelector(bailiffJobDetailSelector);

  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    const value = moment().add(10, "minutes");
    setCountdown(value);
  }, [detail]);
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderer = ({ minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return <span style={{ color: "red" }}>Mã QR đã hết hạn</span>;
    } else {
      // Render a countdown
      return (
        <div>
          <div style={{ color: "#d62f35", fontSize: 16 }}>
            Đơn hàng sẽ hết hạn sau
          </div>
          <div className="countdown-control">
            <div>
              <div className="control-item">
                <div style={{ fontWeight: "bold" }}>{zeroPad(minutes, 2)}</div>
                <div style={{ fontSize: 13 }}>Phút</div>
              </div>
              <div className="control-item">
                <div style={{ fontWeight: "bold" }}>{zeroPad(seconds, 2)}</div>
                <div style={{ fontSize: 13 }}>Giây</div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  };
  // -------------------------- MAIN ----------------------------
  if (!countdown) return null;
  return (
    <div
      style={{
        width: "100%",
        textAlign: "center",
        alignItems: "center",
        background: "#f7e4e7",
        marginTop: 30,
        padding: "10px 0px",
        borderRadius: 10,
      }}
    >
      <Countdown
        renderer={renderer}
        className="order-countdown"
        date={countdown}
      />
    </div>
  );
};
export default ConfirmCountdown;
